import React from 'react';
import PropTypes from 'prop-types';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { DrawerLayoutWrapper } from 'common';
import ProgressBar from 'feature/dispatching/components/ProgressBar';

const statusBoxStyles = {
  alignItems: 'center',
  backgroundColor: 'graphic.light',
  borderRadius: 0.5,
  display: 'flex',
  gridColumn: '1/3',
  height: 20,
  justifyContent: 'center',
  mb: 2,
  width: 54,
};

const accordionStyles = {
  boxShadow: 'none',
};
const accordionDetailsStyles = {
  backgroundColor: 'surface.white',
  p: 0,
  pl: 1,
  pr: 1.5,
};

const Summary = ({ onClose, next, prev, driverState }) => {
  const { firstName, lastName, driversLicense, driversLicenseState, locations } = driverState;

  const buttons = (
    <Box sx={{ display: 'flex', justifyContent: 'space-around', width: 1 }}>
      <Button onClick={prev} sx={{ width: 150 }} variant="outlined">
        Back
      </Button>
      <Button onClick={next} sx={{ width: 150 }}>
        Submit
      </Button>
    </Box>
  );

  return (
    <DrawerLayoutWrapper
      buttons={buttons}
      headerButtonText="CLOSE"
      onHeaderButtonClick={onClose}
      title="New Driver"
    >
      <ProgressBar
        label="Summary (3 of 4)"
        sx={{
          '&.MuiLinearProgress-colorPrimary > .MuiLinearProgress-bar': {
            borderRadius: '10px',
          },
        }}
        value={75}
      />
      <Stack spacing={2} sx={{ p: 3 }}>
        <Typography gutterBottom variant="caption">
          Name
        </Typography>
        <Typography gutterBottom variant="body1bold">
          {lastName}, {firstName}
        </Typography>
        <Box sx={statusBoxStyles}>
          <Typography variant="caption">Inactive</Typography>
        </Box>
        <Typography gutterBottom variant="caption">
          Driver’s License #
        </Typography>
        <Typography sx={{ mb: 2 }} variant="body1bold">
          {driversLicense}
        </Typography>
        <Typography gutterBottom variant="caption">
          Driver’s License State
        </Typography>
        <Typography sx={{ mb: 2 }} variant="body1bold">
          {driversLicenseState.name}
        </Typography>
      </Stack>
      <Divider />
      <Accordion sx={accordionStyles}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ height: 56 }}>
          <Stack direction="row" justifyContent="space-between" sx={{ width: '100%' }}>
            <Typography variant="body1">Locations</Typography>
            <Chip
              label={locations.length}
              sx={{ backgroundColor: 'graphic.light', height: 20, mr: 2 }}
            />
          </Stack>
        </AccordionSummary>
        <AccordionDetails sx={accordionDetailsStyles}>
          {locations.map(({ locationId, name }) => (
            <Typography gutterBottom key={locationId} sx={{ px: 2 }} variant="subtitle2">
              {name}
            </Typography>
          ))}
        </AccordionDetails>
      </Accordion>
    </DrawerLayoutWrapper>
  );
};

Summary.propTypes = {
  driverState: PropTypes.shape({
    driversLicense: PropTypes.string,
    driversLicenseState: PropTypes.shape({
      name: PropTypes.string,
    }),
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    locations: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  next: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  prev: PropTypes.func.isRequired,
};

export default Summary;
